export default function () {
    const partnerObject = window.__partnerObject || "po";
    return window[partnerObject];
}
